
import React from "react";
import { useNavigate } from "react-router-dom";
import "./PairCard.css";
import MiniChart from "./MiniChart";

const PairCard = ({
  pair,
  chart = [],
  marketLocked = false,
}) => {
  const navigate = useNavigate();

  // Fungua TradingView ya pair husika
  const openTradingView = (action = "buy") => {
    const symbol = pair?.pair || "";
    const apiSymbol = pair?.apiSymbol || symbol;

    navigate(
      `/tradingview?symbol=${encodeURIComponent(symbol)}&action=${encodeURIComponent(action)}&apiSymbol=${encodeURIComponent(apiSymbol)}`
    );
  };

  return (
    <div
      className="pair-card"
      onClick={() => openTradingView("buy")}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          openTradingView("buy");
        }
      }}
      aria-label={`Open ${pair.pair} TradingView`}
    >

{marketLocked && (
  <div className="market-locked-badge">
    🔒 LOCKED
  </div>
)}

      {/* =========================
          HEADER
      ========================== */}
      <div className="pair-header">
        <div className="pair-name">
          {pair.pair}

          <span className="star">☆</span>
        </div>

        {/* CHART ICON */}
        <button
          type="button"
          className="candle-button"
          onClick={(e) => {
            e.stopPropagation();
            openTradingView("buy");
          }}
          title={`Open ${pair.pair} chart`}
          aria-label={`Open ${pair.pair} chart`}
        >
          <span className="candle-icon">📈</span>
        </button>
      </div>

      {/* =========================
          SPREAD
      ========================== */}
      <div className="spread">{pair.spread}</div>

      {/* =========================
          CONTENT
      ========================== */}
      <div className="pair-content">
        {/* SELL SIDE */}
        <div className="side">
          <div className="price sell-price">
            {pair.bid}
          </div>

          <button
            type="button"
            className="sell-btn"
            onClick={(e) => {
              e.stopPropagation();
              openTradingView("sell");
            }}
            aria-label={`Sell ${pair.pair}`}
          >
            Sell
          </button>
        </div>

        {/* MINI CHART */}
        <div className="chart">
          <MiniChart
            prices={chart}
            trend={pair.trend}
          />
        </div>

        {/* BUY SIDE */}
        <div className="side">
          <div className="price buy-price">
            {pair.ask}
          </div>

          <button
            type="button"
            className="buy-btn"
            onClick={(e) => {
              e.stopPropagation();
              openTradingView("buy");
            }}
            aria-label={`Buy ${pair.pair}`}
          >
            Buy
          </button>
        </div>
      </div>
    </div>
  );
};

export default PairCard;
